import { setPatientAlerts } from 'actions';
import { setPatientMeasurments } from 'actions';
import { initialMesutments } from 'consts';
import React, { useEffect, useState } from 'react'
import { connect, useDispatch } from 'react-redux'
import useWebSocket from 'react-use-websocket';
import Cookies from "js-cookie";
import { useHistory } from "react-router-dom";
import { setSocketConnectionId } from 'actions';
import { MESSAGE_TYPE } from 'consts';
import { CHANNEL_MESSAGE_ACTION } from 'consts';
import { MESSAGE_PLATFORM } from 'consts';

export const WebsocketPatient = ({ setMeasurments, setAlerts, user }) => {
  const { sendMessage, lastMessage } = useWebSocket(`${process.env.REACT_APP_SOCKET_URL}?id=${user?.data?.id}&user_type=${user.type}&platform=portal&jwtToken=${user.jwtToken}`)
  const [cUser, setCUser] = useState(JSON.parse(Cookies.get('user') || null))
  const history = useHistory()
  const dispatch = useDispatch()

  useEffect(() => {
    const emptyMeaurments = initialMesutments(user.data)
    setMeasurments(emptyMeaurments)
  }, [])

  useEffect(() => {
    const checkMessage = () => {
      if (lastMessage !== null) {
        const { data: massageData } = lastMessage
        try {
          const jsonData = JSON.parse(massageData)
          const { data } = jsonData
          if(!data) return
          const { onAlert, uuid_connection } = data
          if (uuid_connection) {
            invite(uuid_connection)
            return dispatch(setSocketConnectionId(uuid_connection))
          }
          if (onAlert) {//check if it is socket measurments data
            delete data.onAlert
            setMeasurments(data)
            setAlerts(onAlert)
          }
        }
        catch (error) {
          console.log('socket data is invalid json', error)
        }
      }
    }
    checkMessage()
  }, [lastMessage]);


  const invite = (uuid_connection) => {
    try {
      sendMessage(JSON.stringify({
        type: MESSAGE_TYPE.CHANNEL,
        action: CHANNEL_MESSAGE_ACTION.JOIN,
        from: {
          source_id: user.data.id,
          source_type: user.type,
          connection_id: uuid_connection,
          platform: MESSAGE_PLATFORM.PORTAL,
        },
        to: []
      }))
    } catch (err) {
      console.log('err', err)
    }
  }

  return (<div />)
}

const mapStateToProps = (state) => ({})

const mapDispatchToProps = { setMeasurments: setPatientMeasurments, setAlerts: setPatientAlerts }

export default connect(mapStateToProps, mapDispatchToProps)(WebsocketPatient)
